var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModelCheckbox',{staticClass:"acknowledgment",attrs:{"label":"Я это знаю","input-value":_vm.item.userAcknowledgment,"size":"large","disabled":_vm.loading},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }